export default {"src":"/_next/static/media/autocan-logo-white.e9cccb33.svg","height":39,"width":134,"blurWidth":0,"blurHeight":0};